import * as React from "react";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import "./ProjectDetail.less";
import {Button, Divider, Form, Input, InputNumber, message, Modal, Radio, Select} from "antd";
import CutLine from "../../CutLine";
import NavGoBack from "../NavGoBack";
import {consoleApi} from "../../../apiMiddleware";
import {StorageType} from "../driverComponents/AddStorageDriver";
import qiniu_logo from "../../../assets/image/qiniu_icon.svg";
import aliyun_logo from "../../../assets/image/aliyun_icon.svg";
import netless_logo from "../../../assets/image/netless_icon.svg";
import aws_logo from "../../../assets/image/aws_icon.svg";
import {Link} from "@netless/i18n-react-router";
import {ServiceData} from "../../../models/RoomStore";
import {RouteComponentProps, withRouter} from "react-router";
import * as moment from "moment";
import token_icon from "../../../assets/image/token.svg";
import copy from "copy-to-clipboard";
import {CopyOutlined, LoadingOutlined, PlusOutlined} from "@ant-design/icons/lib";
import {FormInstance} from "antd/lib/form";
import { Region, region, regions, setRegion } from "../../../apiMiddleware/region";
import { Lan } from "../../../locale";
const FormItem = Form.Item;
export enum ServiceTypeEnum {
    room = "room",
    snapshot = "snapshot",
    document = "document",
    static_conversion = "static_conversion",
    dynamic_conversion = "dynamic_conversion",
}

const {Option} = Select;

export type ProjectDetailProps = RouteComponentProps<{ uuid: string }> & InjectedIntlProps;

export type ProjectDetailStates = {
    dynamicState: boolean;
    staticState: boolean;
    snapshotState: boolean;
    dynamicAmount: number;
    staticAmount: number;
    isBan: boolean;
    allDrivers: any[];
    projectPhase: ProjectPhaseEnum;
    isMaskLoading: boolean;
    isModalAppear: boolean;
    tokenLoading: boolean;
    sdkToken: string | null;
    services: any[];
};

export enum ProjectPhaseEnum {
    test = "test",
    prod = "prod",
}

class ProjectDetail extends React.Component<ProjectDetailProps, ProjectDetailStates> {
    private readonly formRef: React.RefObject<FormInstance> = React.createRef();
    public constructor(props: ProjectDetailProps) {
        super(props);
        this.state = {
            dynamicState: false,
            staticState: false,
            snapshotState: false,
            dynamicAmount: 0,
            staticAmount: 0,
            isBan: false,
            allDrivers: [],
            projectPhase: ProjectPhaseEnum.test,
            isMaskLoading: false,
            isModalAppear: false,
            tokenLoading: false,
            sdkToken: null,
            services: [],
        };
    }

    private handleServiceState = async (service: ServiceData): Promise<void> => {
        if (service.type === ServiceTypeEnum.dynamic_conversion) {
            this.formRef.current!.setFieldsValue({
                dynamicEnable: service.enable,
            });
            const select = JSON.parse(service.configuration);
            if (select.defaultStorageDriver) {
                this.formRef.current!.setFieldsValue({
                    dynamicSelect: 0,
                });
            } else {
                this.formRef.current!.setFieldsValue({
                    dynamicSelect: select.storageDriverId,
                });
            }

            this.setState({dynamicState: this.formRef.current!.getFieldValue("dynamicEnable")});
            if (service.enable) {
                const res = await consoleApi.driver.getServiceQPS(ServiceTypeEnum.dynamic_conversion);
                if (res.code === 200) {
                    this.formRef.current!.setFieldsValue({
                        dynamicNumber: res.data.concurrentSettings[0].maxConcurrentNumber,
                    });
                    this.updateAmounts({
                        dynamicNumber: res.data.concurrentSettings[0].maxConcurrentNumber,
                    });
                }
            }
        } else if (service.type === ServiceTypeEnum.static_conversion) {
            this.formRef.current!.setFieldsValue({
                staticEnable: service.enable,
            });
            const select = JSON.parse(service.configuration);
            if (select.defaultStorageDriver) {
                this.formRef.current!.setFieldsValue({
                    staticSelect: 0,
                });
            } else {
                this.formRef.current!.setFieldsValue({
                    staticSelect: select.storageDriverId,
                });
            }

            this.setState({staticState: this.formRef.current!.getFieldValue("staticEnable")});
            if (service.enable) {
                const res = await consoleApi.driver.getServiceQPS(ServiceTypeEnum.static_conversion);
                if (res.code === 200) {
                    this.formRef.current!.setFieldsValue({
                        staticNumber: res.data.concurrentSettings[0].maxConcurrentNumber,
                    });
                    this.updateAmounts({
                        staticNumber: res.data.concurrentSettings[0].maxConcurrentNumber,
                    });
                }
            }
        }
    }

    private getConfigData = async (): Promise<void> => {
        const {uuid} = this.props.match.params;
        const resp = await consoleApi.driver.getStorageDriversList();
        if (resp.code === 200) {
            this.setState({allDrivers: resp.data.storageDrivers});
        }

        const service_res = await consoleApi.data.getMyService();
        if (service_res.code === 200) {
            this.setState({ services: service_res.data.services });
            if (service_res.data.services.length > 0) {
                const dynamic_service = service_res.data.services.find((data: any) => data.type === ServiceTypeEnum.dynamic_conversion);
                if (dynamic_service) {
                    await this.handleServiceState(dynamic_service);
                }
                const static_service = service_res.data.services.find((data: any) => data.type === ServiceTypeEnum.static_conversion);
                if (static_service) {
                    await this.handleServiceState(static_service);
                }
                const snapshot_service = service_res.data.services.find((data: any) => data.type === ServiceTypeEnum.snapshot);
                if (snapshot_service) {
                    this.setState({ snapshotState: snapshot_service.enable });
                    this.formRef.current!.setFieldsValue({
                        snapshotEnable: snapshot_service.enable,
                    });
                    const select = JSON.parse(snapshot_service.configuration);
                    if (select.defaultStorageDriver) {
                        this.formRef.current!.setFieldsValue({
                            snapshotSelect: 0,
                        });
                    } else {
                        this.formRef.current!.setFieldsValue({
                            snapshotSelect: select.storageDriverId,
                        });
                    }
                }
            } else {
                this.formRef.current!.setFieldsValue({
                    dynamicEnable: false,
                    dynamicSelect: 0,
                    staticEnable: false,
                    staticSelect: 0,
                    snapshotEnable: false,
                    snapshotSelect: 0,
                });
                this.setState({
                    dynamicState: false,
                    staticState: false,
                    snapshotState: false,
                });
            }
        }
        const res = await consoleApi.project.getAccessKey(uuid);
        if (res.code === 200 && res.data.length > 0) {
            this.formRef.current!.setFieldsValue({
                ak: res.data[0].ak,
                sk: res.data[0].sk,
                isBan: res.data[0].isBan,
            });
        }
        const project_res = await consoleApi.project.getProjectByUuid(this.props.match.params.uuid);
        if (project_res.code === 200) {
            this.formRef.current!.setFieldsValue({
                appIdentifier: `${project_res.data.teamUUID}/${project_res.data.uuid}`,
                createdAt: moment(project_res.data.createdAt).format("L"),
                projectName: project_res.data.name,
            });
        }
    }

    public async componentDidMount(): Promise<void> {
        return this.refreshConfig();
    }

    private async refreshConfig(): Promise<void> {
        try {
            this.setState({isMaskLoading: true});
            await this.getConfigData();
            this.setState({isMaskLoading: false});
        } catch (err) {
            message.error(err.message);
        } finally {
            this.setState({isMaskLoading: false});
        }
    }

    private ensureServiceCreated = async (serviceType: ServiceTypeEnum) => {
        const service = this.state.services.find((s: any) => s.type === serviceType);
        if (!service) {
            await consoleApi.driver.submitServiceDriver({
                type: serviceType,
                configuration: { defaultStorageDriver: true },
            });
        }
    }

    private serviceNeedUpdateState = (serviceType: ServiceTypeEnum, state: boolean) => {
        const service = this.state.services.find((s: any) => s.type === serviceType);
        if (!service) {
            return false;
        }
        if (state === undefined || state === null) {
            return false;
        }
        return service.enable !== state;
    }

    private updateAllInf = async (values: any): Promise<void> => {
        const {uuid} = this.props.match.params;
        try {
            this.setState({isMaskLoading: true});

            if (this.state.staticState) {
                await this.ensureServiceCreated(ServiceTypeEnum.static_conversion);
                await consoleApi.driver.upDateServiceQPS(ServiceTypeEnum.static_conversion, values.staticNumber);

                if (values.staticSelect === 0) {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.static_conversion,
                        configuration: {
                            defaultStorageDriver: true,
                        },
                    });
                } else {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.static_conversion,
                        configuration: {
                            storageDriverId: values.staticSelect,
                        },
                    });
                }
            }

            if (this.state.dynamicState) {
                await this.ensureServiceCreated(ServiceTypeEnum.dynamic_conversion);
                await consoleApi.driver.upDateServiceQPS(ServiceTypeEnum.dynamic_conversion, values.dynamicNumber);
                if (values.dynamicSelect === 0) {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.dynamic_conversion,
                        configuration: {
                            defaultStorageDriver: true,
                        },
                    });
                } else {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.dynamic_conversion,
                        configuration: {
                            storageDriverId: values.dynamicSelect,
                        },
                    });
                }
            }

            if (this.state.snapshotState) {
                await this.ensureServiceCreated(ServiceTypeEnum.snapshot);

                if (values.snapshotSelect === 0) {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.snapshot,
                        configuration: {
                            defaultStorageDriver: true,
                        },
                    });
                } else {
                    await consoleApi.driver.upDateServiceDriver({
                        type: ServiceTypeEnum.snapshot,
                        configuration: {
                            storageDriverId: values.snapshotSelect,
                        },
                    });
                }
            }

            await consoleApi.project.editProjectName(values.projectName, uuid);
            if (this.serviceNeedUpdateState(ServiceTypeEnum.static_conversion, values.staticEnable)) {
                await consoleApi.driver.switchServiceState(ServiceTypeEnum.static_conversion, values.staticEnable);
            }

            if (this.serviceNeedUpdateState(ServiceTypeEnum.dynamic_conversion, values.dynamicEnable)) {
                await consoleApi.driver.switchServiceState(ServiceTypeEnum.dynamic_conversion, values.dynamicEnable);
            }

           if (this.serviceNeedUpdateState(ServiceTypeEnum.snapshot, values.snapshotEnable)) {
                await consoleApi.driver.switchServiceState(ServiceTypeEnum.snapshot, values.snapshotEnable);
           }

            await consoleApi.project.switchAppEnable(uuid, values.ak, values.isBan);
            this.setState({isMaskLoading: false});
            this.props.history.push("/projects/");
            message.success("Information updated successfully");
        } catch (err) {
            message.error(err.message);
            this.setState({isMaskLoading: false});
        }
    }

    private filterServiceType = (type: string) => (driver: any) => {
        if (driver.serviceType) {
            return driver.serviceType === type;
        }
        return true;
    }

    private renderDynamicConfig = (): React.ReactNode => {
        const {intl} = this.props;
        const options = this.state.allDrivers.filter(this.filterServiceType(ServiceTypeEnum.dynamic_conversion)).map((data: any, index: number) => {
            return (
                <Option key={`dynamic-${index}`} value={data.serviceType ? 0 : data.id}>
                    <div className="option-box">
                        {this.renderTinyIcon(data.provider)}
                        <div className="option-text">Bucket: {data.bucket}</div>
                    </div>
                </Option>
            );
        });
        if (this.state.dynamicState) {
            return (
                <>
                    <FormItem name={"dynamicSelect"}>
                        <Select
                            style={{marginTop: 16}}
                            dropdownRender={menu => (
                                <div>
                                    {menu}
                                    <Divider style={{margin: "4px 0"}}/>
                                    {this.renderAddDriver()}
                                </div>
                            )}
                            placeholder={<FormattedMessage id={"config-driver"}/>}>
                            {options}
                        </Select>
                    </FormItem>
                    <FormItem  name={"dynamicNumber"}>
                        <InputNumber formatter={value => `${intl.formatHTMLMessage({id: "qps-web"})}: ${value}`}
                                     style={{marginTop: 16, width: "100%"}} min={1} max={20}
                        />
                    </FormItem>
                    {this.state.dynamicAmount > 0 && <div style={{marginBottom: 24}}>每月需支付 {this.state.dynamicAmount * 600} 元</div>}
                </>
            );
        } else {
            return null;
        }
    }
    // qps-web: 转网页并发
    // qps-pic: 转图片并发
    private renderTinyIcon = (provider: StorageType): React.ReactNode => {
        switch (provider) {
            case StorageType.aliyun: {
                return (
                    <div className="option-logo">
                        <img style={{width: 18}} src={aliyun_logo} alt={"aliyun_logo"}/>
                    </div>
                );
            }
            case StorageType.aws: {
                return (
                    <div className="option-logo">
                        <img style={{width: 18}} src={aws_logo} alt={"aws_logo"}/>
                    </div>
                );
            }
            case StorageType.qiniu: {
                return (
                    <div className="option-logo">
                        <img style={{width: 22}} src={qiniu_logo} alt={"qiniu_logo"}/>
                    </div>
                );
            }
            default: {
                return (
                    <div className="option-logo">
                        <img style={{width: 18}} src={netless_logo} alt={"netless_logo"}/>
                    </div>
                );
            }

        }
    }

    private renderStaticConfig = (): React.ReactNode => {
        const {intl} = this.props;
        const options = this.state.allDrivers.filter(this.filterServiceType(ServiceTypeEnum.static_conversion)).map((data: any, index: number) => {
            return (
                <Option key={`driver-${index}`} value={data.serviceType ? 0 : data.id}>
                    <div className="option-box">
                        {this.renderTinyIcon(data.provider)}
                        <div className="option-text">Bucket: {data.bucket}</div>
                    </div>
                </Option>
            );
        });
        if (this.state.staticState) {
            return (
                <>
                    <FormItem name={"staticSelect"}>
                        <Select
                            style={{marginTop: 16}}
                            dropdownRender={menu => (
                                <div>
                                    {menu}
                                    <Divider style={{margin: "4px 0"}}/>
                                    {this.renderAddDriver()}
                                </div>
                            )}
                            placeholder={<FormattedMessage id={"config-driver"}/>}>
                            {options}
                        </Select>
                    </FormItem>
                    <FormItem name={"staticNumber"}>
                        <InputNumber
                            formatter={value => `${intl.formatHTMLMessage({id: "qps-pic"})}: ${value}`} key={`static-number`}
                            style={{marginTop: 16, width: "100%"}} min={1} max={20}/>
                    </FormItem>
                    {this.state.staticAmount > 0 && <div style={{marginBottom: 24}}>每月需支付 {this.state.staticAmount * 120} 元</div>}
                </>
            );
        } else {
            return null;
        }
    }

    private renderScreenshotConfig = (): React.ReactNode => {
        const options = this.state.allDrivers.filter(this.filterServiceType(ServiceTypeEnum.snapshot)).map((data: any, index: number) => {
            return (
                <Option key={`static-driver-${index}`} value={data.serviceType ? 0 : data.id}>
                    <div className="option-box">
                        {this.renderTinyIcon(data.provider)}
                        <div className="option-text">Bucket: {data.bucket}</div>
                    </div>
                </Option>
            );
        });
        if (this.state.snapshotState) {
            return (
                <FormItem name={"snapshotSelect"}>
                    <Select
                        style={{marginTop: 16}}
                        dropdownRender={menu => (
                            <div>
                                {menu}
                                <Divider style={{margin: "4px 0"}}/>
                                {this.renderAddDriver()}
                            </div>
                        )}
                        placeholder={"配置存储 driver"}>
                        {options}
                    </Select>
                </FormItem>
            );
        } else {
            return null;
        }
    }

    private renderAddDriver = (): React.ReactNode => {
        return (
            <Link to={`/user-center/driver/select-storage-driver/`}>
                <div
                    className="project-add-box"
                    onMouseDown={e => e.preventDefault()}>
                    <PlusOutlined style={{marginLeft: 14, marginRight: 8}}/>
                    <FormattedMessage id={"new-storage-config"}/>
                </div>
            </Link>
        );
    }

    private renderBaseInf = (): React.ReactNode => {
        return (
            <div className="console-content-chart-body">
                <div className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        <FormattedMessage id={"creation-time"}/>:
                    </div>
                    <div className="console-service-app-inner">
                        <FormItem name={"createdAt"}>
                            <Input disabled={true}/>
                        </FormItem>
                    </div>
                </div>
                <div className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        <FormattedMessage id={"project-name"}/>
                    </div>
                    <div className="console-service-app-inner">
                        <FormItem
                            name={"projectName"}
                        >
                            <Input/>
                        </FormItem>
                    </div>
                </div>
                <div className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        AppIdentifier:
                    </div>
                    <div className="console-service-app-inner">
                        <FormItem name={"appIdentifier"}>
                            <Input addonAfter={<CopyOutlined onClick={() => {
                                const appIdentifier = this.formRef.current!.getFieldValue("appIdentifier");
                                if (appIdentifier) {
                                    copy(appIdentifier);
                                    message.success("Copy token to clipboard");
                                }
                            }}/>}
                                   disabled={true}/>
                        </FormItem>
                    </div>
                </div>
                <div className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        AK:
                    </div>
                    <div className="console-service-app-inner">
                        <FormItem name={"ak"}>
                            <Input addonAfter={
                                <CopyOutlined onClick={() => {
                                    const ak = this.formRef.current!.getFieldValue("ak");
                                    if (ak) {
                                        copy(ak);
                                        message.success("Copy token to clipboard");
                                    }
                                }}/>
                            }
                                   disabled={true}/>
                        </FormItem>
                    </div>
                </div>
                <div className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        SK:
                    </div>
                    <div className="console-service-app-inner">
                        <FormItem name={"sk"}>
                            <Input addonAfter={
                                <CopyOutlined onClick={() => {
                                    const sk = this.formRef.current!.getFieldValue("sk");
                                    if (sk) {
                                        copy(sk);
                                        message.success("Copy token to clipboard");
                                    }
                                }}/>
                            }
                                   disabled={true}/>
                        </FormItem>
                    </div>
                </div>
                <div style={{marginBottom: 24}} className="console-service-app">
                    <div style={{marginTop: 4}} className="console-service-app-title">
                        sdkToken:
                    </div>
                    <div className="console-service-app-inner">
                        <Button
                            // disabled={this.state.sk === "" || this.state.ak === ""}
                            onClick={() => {
                                this.setState({isModalAppear: true});
                            }}>
                            <FormattedMessage id={"generate-sdkToken"}/>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined style={{fontSize: 36, color: "#3381FF"}}/>
                </div>
            );
        } else {
            return null;
        }
    }

    private handleToken = async (): Promise<void> => {
        try {
            const ak = this.formRef.current!.getFieldValue("ak");
            const sk = this.formRef.current!.getFieldValue("sk");
            this.setState({tokenLoading: true});
            const res = await consoleApi.project.getProjectToken(ak, sk);
            if (res.code === 200) {
                this.setState({sdkToken: res.data.sdkToken, tokenLoading: false});
            }
        } catch (err) {
            message.error(err.message);
            this.setState({tokenLoading: false});
        }
    }

    private updateAmounts = (e: Partial<{ dynamicNumber: number, staticNumber: number }>) => {
        if (e.dynamicNumber) {
            this.setState({ dynamicAmount: e.dynamicNumber });
        }
        if (e.staticNumber) {
            this.setState({ staticAmount: e.staticNumber });
        }
    }

    private getLang(): Lan {
        return window.location.pathname.split("/")[1] as Lan;
    }

    private onChangeRegion = (_region: Region): void => {
        setRegion(_region);
        this.refreshConfig();
    }

    public render(): React.ReactNode {
        return (
            <Form ref={this.formRef} onValuesChange={this.updateAmounts} onFinish={this.updateAllInf}>
                <NavGoBack title={<FormattedMessage id={"edit-item"}/>}/>
                <Modal
                    width={600}
                    key={"modal"}
                    title={<FormattedMessage id={"generate-sdkToken"}/>}
                    centered
                    visible={this.state.isModalAppear}
                    footer={null}
                    onOk={() => {
                        this.setState({isModalAppear: false});
                    }}
                    onCancel={() => {
                        this.setState({isModalAppear: false, sdkToken: null});
                    }}
                >
                    {this.state.sdkToken ? <div className="driver-modal-box-inner">
                            <div className="sdkToken-alert">
                                <FormattedMessage id={"token-tips"}/>
                            </div>
                            <div
                                className="clipboard-inner">
                                {this.state.sdkToken}
                            </div>
                            <Button onClick={() => {
                                if (this.state.sdkToken) {
                                    copy(this.state.sdkToken);
                                    message.success("Copy token to clipboard");
                                }
                            }} type="primary" style={{marginTop: 24}}>
                                <FormattedMessage id={"copy-token"}/>
                            </Button>
                        </div> :
                        <div className="driver-modal-box-inner">
                            <img style={{width: 240}} src={token_icon} alt={"token"}/>
                            <Button
                                type="primary"
                                loading={this.state.tokenLoading}
                                onClick={this.handleToken}
                                style={{marginTop: 24}}>
                                <FormattedMessage id={"click"}/>
                            </Button>
                        </div>
                    }
                </Modal>
                <div className="product-center-box">
                    <div className="portal-room-outbox">
                        <div className="portal-room-chart-measure">
                            {this.renderMask()}
                            <div className="portal-room-box-mid">
                                <div className="console-content-title-app">
                                    <span style={{marginTop: 48}} className="console-content-app-text">
                                        <FormattedMessage id={"basic-information"}/>
                                    </span>
                                </div>
                                {this.renderBaseInf()}
                            </div>
                            <CutLine/>
                            <div className="portal-room-box-mid">
                                <div className="console-content-title-app">
                                <span style={{marginTop: 48}} className="console-content-app-text">
                                    <FormattedMessage id={"services"}/>
                                </span>
                                </div>
                                <div className="console-content-chart-body">
                                    <div className="console-service-app">
                                        <div className="console-service-app-title">
                                            <FormattedMessage id={"global.region"}/>:
                                        </div>
                                        <div className="console-service-app-inner">
                                            <FormItem name={"regionSelect"}>
                                                <Select defaultValue={region} onChange={this.onChangeRegion}>
                                                    {regions[this.getLang()].map(({ name, region, emoji }) => (
                                                        <Option key={region} value={region}>{emoji} {name}</Option>
                                                    ))}
                                                </Select>
                                            </FormItem>
                                        </div>
                                    </div>
                                    <div className="console-service-app">
                                        <div className="console-service-app-title">
                                            <FormattedMessage id={"document-to-picture"}/>:
                                        </div>
                                        <div className="console-service-app-inner">
                                            <FormItem name={"staticEnable"}>
                                                <Radio.Group
                                                    onChange={evt => {
                                                        this.setState({staticState: evt.target.value});
                                                    }}
                                                >
                                                    <Radio value={true}><FormattedMessage id={"enable"}/></Radio>
                                                    <Radio value={false}><FormattedMessage id={"disable"}/></Radio>
                                                </Radio.Group>
                                            </FormItem>
                                            {this.renderStaticConfig()}
                                        </div>
                                    </div>
                                    <div className="console-service-app">
                                        <div className="console-service-app-title">
                                            <FormattedMessage id={"document-to-web"}/>:
                                        </div>
                                        <div className="console-service-app-inner">
                                            <FormItem name={"dynamicEnable"}>
                                                <Radio.Group
                                                    onChange={evt => {
                                                        this.setState({dynamicState: evt.target.value});
                                                    }}
                                                >
                                                    <Radio value={true}><FormattedMessage id={"enable"}/></Radio>
                                                    <Radio value={false}><FormattedMessage id={"disable"}/></Radio>
                                                </Radio.Group>
                                            </FormItem>
                                            {this.renderDynamicConfig()}
                                        </div>
                                    </div>
                                    <div style={{marginBottom: 24}} className="console-service-app">
                                        <div className="console-service-app-title">
                                            <FormattedMessage id={"screenshot"}/>
                                        </div>
                                        <div className="console-service-app-inner">
                                            <FormItem name={"snapshotEnable"}>
                                                <Radio.Group
                                                    onChange={evt => {
                                                        this.setState({snapshotState: evt.target.value});
                                                    }}
                                                >
                                                    <Radio value={true}><FormattedMessage id={"enable"}/></Radio>
                                                    <Radio value={false}><FormattedMessage id={"disable"}/></Radio>
                                                </Radio.Group>
                                            </FormItem>
                                            {this.renderScreenshotConfig()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CutLine/>
                            <div className="portal-room-box-mid">
                                <div className="console-content-title-app">
                                <span style={{marginTop: 48}} className="console-content-app-text">
                                    <FormattedMessage id={"project-status"}/>
                                </span>
                                </div>
                                <div style={{marginBottom: 24}} className="console-content-chart-body">
                                    <div className="console-service-app">
                                        <div className="console-service-app-title">
                                            <FormattedMessage id={"project-status"}/>:
                                        </div>
                                        <div className="console-service-app-inner">
                                            <FormItem name={"isBan"}>
                                                <Radio.Group>
                                                    <Radio value={false}><FormattedMessage id={"enable"}/></Radio>
                                                    <Radio value={true}><FormattedMessage id={"disable"}/></Radio>
                                                </Radio.Group>
                                            </FormItem>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CutLine/>
                            <div className="portal-room-box-mid">
                                <div className="console-service-app-btn">
                                    <FormItem>
                                        <Button htmlType="submit" type="primary"
                                                          style={{marginRight: 16, width: 120}}>
                                            <FormattedMessage id={"save"}/>
                                        </Button>
                                        <Link to={"/projects/"}>
                                            <Button style={{width: 120}}>
                                                <FormattedMessage id={"cancel"}/>
                                            </Button>
                                        </Link>
                                    </FormItem>
                                    <Link to={`/projects/delete/${this.props.match.params.uuid}/`}>
                                        <div className="project-delete">
                                            彻底删项目
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}


export default withRouter(injectIntl(ProjectDetail));



// WEBPACK FOOTER //
// ./src/components/portal/serviceCenter/ProjectDetail.tsx